export default function ContactForm() {
  return (
    <form
      name="quote-form"
      method="POST"
      data-netlify="true"
      encType="multipart/form-data"
      style={{ display: "flex", flexDirection: "column", width: "300px" }}
    >
      <input type="hidden" name="form-name" value="quote-form" />

      <input type="text" name="name" placeholder="Name" required />
      <input type="email" name="email" placeholder="Email" required />
      <textarea name="description" placeholder="Requirement" />

      <input type="file" name="file" />

      <button type="submit">Submit</button>
    </form>
  );
}
